const _ = require('lodash')

const searchPage = (page, search) => {
  return validateStringValues(page, search)
}

const searchComponent = (component, search, options) => {
  const { data } = component
  const { node, name, property } = data

  const { voicePaths } = options

  // API: Name, URL, Body
  if (node === 'api') {
    return (
      validateStringValues(name, search) ||
      validateStringValues(property.url, search) ||
      validateStringValues(property.body, search)
    )
  }
  // Checkpoint: Name
  else if (node === 'checkpoint') {
    return validateStringValues(name, search)
  }
  // Code: Code
  else if (node === 'code') {
    return validateStringValues(property.code, search)
  }
  // Condition: Name, Condition
  else if (node === 'condition') {
    return (
      validateStringValues(name, search) ||
      validateArrayValues(property.conditions, 'condition', search)
    )
  }
  // Disconnect: Return VXML
  else if (node === 'disconnect') {
    return validateStringValues(property.vxml, search)
  }
  // Gen AI: Name, Gen AI model, Message
  else if (node === 'gen_ai') {
    return (
      validateStringValues(name, search) ||
      validateStringValues(property.gen_ai, search) ||
      validateStringValues(property.message, search)
    )
  }
  // Input: Name
  else if (node === 'input') {
    return validateStringValues(name, search)
  }
  // Intent mapping: Name, Intent variable
  else if (node === 'intent_mapping') {
    return (
      validateStringValues(name, search) ||
      validateStringValues(property.intent_variable, search)
    )
  }
  // Loop: Variable
  else if (node === 'loop') {
    return validateStringValues(property.variable, search)
  }
  // Mail: Name, To, Cc, Subject, Content, Attachment file name
  else if (node === 'mail') {
    return (
      validateStringValues(name, search) ||
      validateStringValues(property.to, search) ||
      validateStringValues(property.cc, search) ||
      validateStringValues(property.subject, search) ||
      validateStringValues(property.body, search) ||
      validateArrayValues(property.attachments, 'file_name', search)
    )
  }
  // Prompt: Name, Text to speech, Static audio filename, Static audio transcription, Variable, URL to audio, URL transcription
  else if (node === 'prompt') {
    let cloneBotSays = _.cloneDeep(property.bot_says)
    cloneBotSays = cloneBotSays.map(el => {
      if (el.type === 'file') {
        const findPath = _.find(voicePaths, { path: el.path })
        el.transcription = findPath ? findPath.text : ''
      }
      return el
    })

    return (
      validateStringValues(name, search) ||
      validateArrayValues(cloneBotSays, 'text', search) ||
      validateArrayValues(cloneBotSays, 'path', search) ||
      validateArrayValues(cloneBotSays, 'transcription', search) ||
      validateArrayValues(cloneBotSays, 'variable', search) ||
      validateArrayValues(cloneBotSays, 'url', search) ||
      validateArrayValues(cloneBotSays, 'transcription', search)
    )
  }
  // Random: Name
  else if (node === 'random') {
    return validateStringValues(name, search)
  }
  // Schedule: Schedule name
  else if (node === 'schedule') {
    return validateStringValues(property.schedule_name, search)
  }
  // Stamp service: Name, Metadata
  else if (node === 'stamp_service') {
    return (
      validateStringValues(name, search) ||
      validateStringValues(property.metadata, search)
    )
  }
  // Transfer: Name, Flow name, Contact name, Number, Name, Queue name, SIP header, Append to number, Return VXML
  else if (node === 'transfer') {
    return (
      validateStringValues(name, search) ||
      validateStringValues(property.flow_ui_name, search) ||
      validateStringValues(property.contact_name, search) ||
      validateStringValues(property.number, search) ||
      validateStringValues(property.number_name, search) ||
      validateStringValues(property.queue_name, search) ||
      validateStringValues(property.integration_detail_sip_header, search) ||
      validateStringValues(
        property.integration_detail_append_to_number,
        search
      ) ||
      validateStringValues(property.vxml, search)
    )
  }
  // Write: Name, Field name, Field names (clear operation), [Set] to value, [Prepend] with, [Append] with, [Lookup] Search key, [Lookup] Lookup table, [Lookup] Default value if not found
  else if (node === 'write') {
    return (
      validateStringValues(name, search) ||
      validateStringValues(property.field_name, search) ||
      validateStringValues(property.fields_name, search) ||
      validateStringValues(property.value, search) ||
      validateStringValues(property.searching_key, search) ||
      validateStringValues(property.lookup_table_name, search) ||
      validateStringValues(property.default_value, search)
    )
  }

  return false
}

const validateStringValues = (value, search) => {
  if (!value) return false
  if (!search) return false

  const inValue = value.toString().toLowerCase()
  const inSearch = search.toLowerCase()

  return inValue.includes(inSearch)
}

const validateArrayValues = (valuesArray, field, search) => {
  for (let i = 0; i < valuesArray.length; i++) {
    const item = valuesArray[i][field]
    const result = validateStringValues(item, search)
    if (result) {
      return true
    }
  }
  return false
}

module.exports = { searchPage, searchComponent }
